import { Icon, IconProps } from './Icon';

export const SmartToolsNavigatorIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      d="M17.7273 6.61523H6.27273C5.56982 6.61523 5 7.20071 5 7.92293V13.1537C5 13.8759 5.56982 14.4614 6.27273 14.4614H17.7273C18.4302 14.4614 19 13.8759 19 13.1537V7.92293C19 7.20071 18.4302 6.61523 17.7273 6.61523Z"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M17.7273 14.4619H6.27273C5.56982 14.4619 5 15.0474 5 15.7696V18.385C5 19.1072 5.56982 19.6927 6.27273 19.6927H17.7273C18.4302 19.6927 19 19.1072 19 18.385V15.7696C19 15.0474 18.4302 14.4619 17.7273 14.4619Z"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M17.7273 6.61538H6.27273C5.93547 6.61441 5.61229 6.47633 5.37382 6.2313C5.13534 5.98627 5.00094 5.65422 5 5.30769C5.00094 4.96117 5.13534 4.62912 5.37382 4.38409C5.61229 4.13906 5.93547 4.00097 6.27273 4H17.7273C18.0645 4.00097 18.3877 4.13906 18.6262 4.38409C18.8647 4.62912 18.9991 4.96117 19 5.30769C18.9991 5.65422 18.8647 5.98627 18.6262 6.2313C18.3877 6.47633 18.0645 6.61441 17.7273 6.61538ZM7.54545 19.6923V20.5913C7.54545 20.6997 7.50355 20.8037 7.42896 20.8803C7.35437 20.9569 7.25321 21 7.14773 21H6.03409C5.92861 21 5.82744 20.9569 5.75286 20.8803C5.67827 20.8037 5.63636 20.6997 5.63636 20.5913V19.6923H7.54545ZM18.3636 19.6923V20.5913C18.3636 20.6997 18.3217 20.8037 18.2471 20.8803C18.1726 20.9569 18.0714 21 17.9659 21H16.8523C16.7468 21 16.6456 20.9569 16.571 20.8803C16.4964 20.8037 16.4545 20.6997 16.4545 20.5913V19.6923H18.3636Z"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M16.4547 17.7305C16.8062 17.7305 17.0911 17.4378 17.0911 17.0767C17.0911 16.7156 16.8062 16.4229 16.4547 16.4229C16.1033 16.4229 15.8184 16.7156 15.8184 17.0767C15.8184 17.4378 16.1033 17.7305 16.4547 17.7305Z"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M7.54554 17.7305C7.897 17.7305 8.18191 17.4378 8.18191 17.0767C8.18191 16.7156 7.897 16.4229 7.54554 16.4229C7.19409 16.4229 6.90918 16.7156 6.90918 17.0767C6.90918 17.4378 7.19409 17.7305 7.54554 17.7305Z"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12 6.61531V14.4615M5 5.30762V17.0768M19 5.30762V17.0768"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
